module.exports = __webpack_public_path__ + "static/Classroom-Activity-2-2-Weight-based-bullying-What-can-I-do-0d045ca07555c00481a9c3ac3b2ac0d1.pdf";